module.exports = __webpack_public_path__ + "static/images/ui/ui-bg_gloss-wave_25_333333_500x100.png";